import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c84b7060"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "読み込み中...", -1))


import LoadingSpinner from "@/assets/svgs/loading_spinner.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
    isLoading: { type: Boolean },
    isFixed: { type: Boolean },
    isCenter: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{
      'loading-message-fixed': _ctx.isFixed,
      'loading-message-center': _ctx.isCenter,
    }, "loading-message"])
        }, [
          _createElementVNode("p", null, [
            _createVNode(_unref(LoadingSpinner))
          ]),
          _hoisted_1
        ], 2))
      : _createCommentVNode("", true),
    ((_ctx.isFixed || _ctx.isCenter) && _ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["loading-message-background", {
      'loading-message-background-center': _ctx.isCenter,
    }])
        }, null, 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})